import React, { useEffect } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import PublishersTable from "../Publishers/PublishersTable";

const Publishers = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Animation happens only once
        });
    }, []);

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    {/* Main Content */}
                    <main className="pt-[60px] px-4">
                        <div className="mt-6">
                            <PublishersTable />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Publishers;
